<template>
  <div
    class="d-flex px-sm-3 px-md-5 my-4 justify-content-between topics-container flex-gap overflow-auto"
  >
    <b-button
      variant="outline-info"
      class="px-4 py-2 topics-container__button"
      pill
      v-for="topic in topics"
      :key="topic.id"
      @click.stop="handleClick(topic.id)"
      >{{ topic.name }}</b-button
    >
  </div>
</template>
<script>
export default {
  props: {
    topics: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleClick(topicId) {
      this.$emit('onTopicClick', topicId);
    },
  },
};
</script>
<style lang="scss" scoped>
.topics-container {
  @media screen and (min-width: 1025px) {
    padding: 0 5rem !important;
  }

  &__button {
    min-width: 155px;
  }
}
</style>
